<h2 class="notion-heading-1 px-[16px] mt-[16px] mb-[8px]">
  @for(c of data.heading_1.rich_text; track $index) {
  <app-notion-text-component [data]="c"></app-notion-text-component>
  }
</h2>
